<template>
    <transition name="modal">
        <div class="modal__mask modalpep" v-if="showModalCreate">
            <div class="modal__wrapper">
                <div class="modal__container reset">
                    <div class="content__modal">


                        <div class="inner__modal_pep">
                            <img style="width: 40px; height: 47px;" src="@/assets/question.png" />
                            <h2>PEP - Pessoa Exposta Politicamente </h2>

                            <span>
                                Consideram-se pessoas expostas politicamente os agentes públicos que desempenham ou tenham desempenhado, nos cinco anos anteriores, no Brasil ou em países, territórios e dependências estrangeiras, cargos, empregos ou funções públicas relevantes, assim como seus representantes, familiares e outras pessoas de seu relacionamento próximo, conforme disposto no Anexo A. 
                                <br/>
                                <br/>
                                <strong>Resolução CVM nº 50/2021, art. 5º, Anexo A e a Circular BCB nº 3.978/2020.</strong>
                            </span>

                            
                      <div class="buttonsAcoes" style="padding-bottom: 30px;">
                          <button class="btnDefault" style="width: 290px" @click="closeModal">Entendi</button>
                      </div>


                        </div>

                        

                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    computed: {
        ...mapGetters({
            showModalCreate: "GET_MODAL_PEP_INFORMATIVO",
            user: 'auth/user',
        }),
    },
    methods: {
        closeModal() {
            this.$store.commit("SET_MODAL_PEP_INFORMATIVO", false);
            
        },
    },
};
</script>

<style lang="scss">
 

@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');



</style>
